/*!
 * AOCHUAN — frontend localization (DISPLAY ONLY)
 * Converts USD prices for display + drives the Shopify locale switcher.
 * Never touches Shopify product/variant/cart/checkout/order data.
 */
(function () {
  'use strict';

  /* =====================================================================
   * 1. CURRENCY CONFIGURATION — the single source of truth.
   *    Add a new currency here only; nothing else needs to change.
   * ===================================================================== */
  var CONFIG = {
    baseCurrency: 'USD',        // Shopify backend currency — never changes
    defaultCurrency: 'USD',     // used when detection fails or rate is missing
    storageKey: 'aoc_currency_v1',
    rateCacheKey: 'aoc_rates_usd_v1',
    refreshHours: 24,           // exchange rates are refreshed at most once a day

    rateSources: [
      'https://open.er-api.com/v6/latest/USD',
      'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json'
    ],

    // Offline safety net (snapshot). Used until the first successful refresh.
    fallbackRates: {
      USD: 1, EUR: 0.8596, GBP: 0.7380, JPY: 153.59, CAD: 1.3795, AUD: 1.3847,
      CNY: 6.7255, HKD: 7.8424, SGD: 1.2642, KRW: 1339.00, CHF: 0.8095
    },

    currencies: [
      { code: 'USD', symbol: '$',  decimals: 2 },
      { code: 'EUR', symbol: '€',  decimals: 2 },
      { code: 'GBP', symbol: '£',  decimals: 2 },
      { code: 'JPY', symbol: '¥',  decimals: 0 },
      { code: 'CAD', symbol: 'C$', decimals: 2 },
      { code: 'AUD', symbol: 'A$', decimals: 2 }
    ],

    // Detection order: first hit wins. Lighter = earlier.
    detectOrder: ['timezone', 'language', 'shopify'],

    countryCurrency: {
      US: 'USD',
      DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR', AT: 'EUR',
      PT: 'EUR', IE: 'EUR', FI: 'EUR', GR: 'EUR', HR: 'EUR', CY: 'EUR', EE: 'EUR',
      LV: 'EUR', LT: 'EUR', LU: 'EUR', MT: 'EUR', SK: 'EUR', SI: 'EUR', BG: 'EUR',
      GB: 'GBP', JP: 'JPY', CA: 'CAD', AU: 'AUD'
    },

    // Timezone -> country (physical location proxy, no network needed).
    timezoneCountry: {
      'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US',
      'America/Phoenix': 'US', 'America/Los_Angeles': 'US', 'America/Anchorage': 'US',
      'Pacific/Honolulu': 'US', 'America/Toronto': 'CA', 'America/Vancouver': 'CA',
      'America/Edmonton': 'CA', 'America/Winnipeg': 'CA', 'America/Halifax': 'CA',
      'America/St_Johns': 'CA',
      'Europe/London': 'GB', 'Europe/Dublin': 'IE',
      'Europe/Berlin': 'DE', 'Europe/Busingen': 'DE', 'Europe/Paris': 'FR',
      'Europe/Madrid': 'ES', 'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL',
      'Europe/Brussels': 'BE', 'Europe/Vienna': 'AT', 'Europe/Lisbon': 'PT',
      'Europe/Helsinki': 'FI', 'Europe/Athens': 'GR', 'Europe/Zagreb': 'HR',
      'Europe/Nicosia': 'CY', 'Europe/Tallinn': 'EE', 'Europe/Riga': 'LV',
      'Europe/Vilnius': 'LT', 'Europe/Luxembourg': 'LU', 'Europe/Malta': 'MT',
      'Europe/Bratislava': 'SK', 'Europe/Ljubljana': 'SI', 'Europe/Sofia': 'BG',
      'Asia/Tokyo': 'JP', 'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU',
      'Australia/Brisbane': 'AU', 'Australia/Perth': 'AU', 'Australia/Adelaide': 'AU'
    },

    // Elements holding a price for display. Leaf elements win (no double conversion).
    priceSelectors: [
      '.money',
      '.gc-price',
      '.gc-tile__price',
      '.aochuan-product-showcase__price',
      '.aochuan-product-showcase__price-compare',
      '.pp-price',
      '.pp-saving',
      '.pp-disc-savings',
      '.cmp__val',
      '[data-cart-subtotal]'
    ],

    // Containers watched for late DOM writes (variant change, cart ajax).
    watchSelectors: [
      '.pp-price',
      '.cart-items-container',
      '.cart-tools',
      '.cart-price-info',
      '.aochuan-product-showcase__prices',
      '.gc-tile__price'
    ],

    showCartNotice: true,
    protectThemeReads: true,   // keep theme JS reading the original USD text (no double conversion)

    pendingClass: 'aocl-pending',
    activeAttr: 'data-aocl-cur'
  };

  var DATA = window.AOC_LOCALIZATION_DATA || {};
  var STRINGS = {
    currency: 'Currency',
    language: 'Language',
    selectorLabel: 'Currency and language',
    notice: 'Prices are shown in your selected currency. Final payment is processed by the payment provider.'
  };
  if (DATA.strings) { for (var sk in DATA.strings) { if (DATA.strings[sk]) { STRINGS[sk] = DATA.strings[sk]; } } }

  var PRICE_SELECTOR = CONFIG.priceSelectors.join(',');
  var SKIP_SELECTOR = 'script,style,noscript,template,[data-aocl-skip],.aocl-panel';
  var USD_RE = /\$\s?(\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)/g;
  var OTHER_SYMBOL_RE = /[€£¥₩₹₽₺₪₫฿₱₦]|C\$|A\$|HK\$|S\$|R\$|NZ\$/;

  /* =====================================================================
   * 2. CURRENCY CONFIGURATION HELPERS
   * ===================================================================== */
  var CURRENCIES = {};
  var CURRENCY_LIST = (function () {
    var out = [];
    for (var i = 0; i < CONFIG.currencies.length; i++) {
      var c = CONFIG.currencies[i];
      if (!c || !c.code) { continue; }
      c.code = String(c.code).toUpperCase();
      if (typeof c.decimals !== 'number') { c.decimals = 2; }
      if (!c.symbol) { c.symbol = c.code; }
      CURRENCIES[c.code] = c;
      out.push(c);
    }
    return out;
  })();

  function isSupported(code) {
    return !!CURRENCIES[String(code || '').toUpperCase()];
  }
  function currencyOf(code) {
    return CURRENCIES[String(code || '').toUpperCase()] || CURRENCIES[CONFIG.defaultCurrency];
  }

  /* =====================================================================
   * 3. COUNTRY DETECTION — synchronous, zero requests
   * ===================================================================== */
  function countryFromTimezone() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return (tz && CONFIG.timezoneCountry[tz]) || null;
    } catch (e) { return null; }
  }
  function countryFromLanguage() {
    try {
      var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
      for (var i = 0; i < langs.length; i++) {
        var m = /^[a-zA-Z]{2,3}[-_]([a-zA-Z]{2})$/.exec(String(langs[i]));
        if (m) { return m[1].toUpperCase(); }
      }
    } catch (e) {}
    return null;
  }
  function countryFromShopify() {
    var c = String(DATA.country || '').toUpperCase();
    return /^[A-Z]{2}$/.test(c) ? c : null;
  }
  function detectCountry() {
    var probes = { timezone: countryFromTimezone, language: countryFromLanguage, shopify: countryFromShopify };
    var order = CONFIG.detectOrder || [];
    for (var i = 0; i < order.length; i++) {
      var fn = probes[order[i]];
      var c = fn ? fn() : null;
      if (c) { return c; }
    }
    return null;
  }
  function detectedCurrency() {
    var country = detectCountry();
    var cur = country ? CONFIG.countryCurrency[country] : null;
    return isSupported(cur) ? cur : CONFIG.defaultCurrency;
  }

  /* =====================================================================
   * 4. CURRENCY PREFERENCE MANAGER (localStorage + safe fallbacks)
   * ===================================================================== */
  function readPreference() {
    try {
      var raw = window.localStorage.getItem(CONFIG.storageKey);
      if (!raw) { return null; }
      var o = JSON.parse(raw);
      return (o && isSupported(o.code)) ? o : null;
    } catch (e) { return null; }
  }
  function writePreference(code, manual) {
    try {
      window.localStorage.setItem(CONFIG.storageKey, JSON.stringify({ code: code, manual: !!manual, ts: Date.now() }));
    } catch (e) {}
  }
  // Priority: manual choice > saved preference > country detection > USD
  function resolveCurrency() {
    var saved = readPreference();
    if (saved && saved.manual) { return saved.code; }
    var detected = detectedCurrency();
    if (isSupported(detected)) { return detected; }
    if (saved) { return saved.code; }
    return CONFIG.defaultCurrency;
  }

  /* =====================================================================
   * 5. EXCHANGE RATE MANAGER (cached, refreshed at most once a day)
   * ===================================================================== */
  var RATES = CONFIG.fallbackRates;
  var rateRequested = false;

  function readRateCache() {
    try {
      var o = JSON.parse(window.localStorage.getItem(CONFIG.rateCacheKey) || 'null');
      return (o && o.rates && o.ts) ? o : null;
    } catch (e) { return null; }
  }
  function writeRateCache(rates) {
    try {
      window.localStorage.setItem(CONFIG.rateCacheKey, JSON.stringify({ rates: rates, ts: Date.now() }));
    } catch (e) {}
  }
  function isFresh(cache) {
    return !!(cache && (Date.now() - cache.ts) < CONFIG.refreshHours * 3600 * 1000);
  }
  function pickSupported(source) {
    var out = {};
    var n = 0;
    for (var i = 0; i < CURRENCY_LIST.length; i++) {
      var code = CURRENCY_LIST[i].code;
      var r = source[code];
      if (typeof r !== 'number') { r = source[String(code).toLowerCase()]; }
      if (typeof r === 'number' && r > 0) { out[code] = r; n++; }
    }
    return n ? out : null;
  }
  function normalizeRates(json) {
    if (!json) { return null; }
    if (json.rates) { return pickSupported(json.rates); }
    if (json.usd) { return pickSupported(json.usd); }
    if (json.conversion_rates) { return pickSupported(json.conversion_rates); }
    return null;
  }
  function rateFor(code) {
    var r = RATES[code];
    if (typeof r === 'number' && r > 0) { return r; }
    r = CONFIG.fallbackRates[code];
    return (typeof r === 'number' && r > 0) ? r : 1;
  }
  function refreshRates(onDone) {
    var cache = readRateCache();
    if (isFresh(cache)) { return; }
    if (rateRequested || !window.fetch) { return; }
    rateRequested = true;

    var sources = CONFIG.rateSources.slice();
    (function tryNext() {
      if (!sources.length) { return; }
      var url = sources.shift();
      window.fetch(url, { credentials: 'omit', cache: 'no-store' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (json) {
          var rates = normalizeRates(json);
          if (!rates) { tryNext(); return; }
          var base = rates.USD || 1;
          for (var k in rates) { rates[k] = rates[k] / base; }
          RATES = rates;
          writeRateCache(rates);
          if (onDone) { onDone(); }
        })
        .catch(function () { tryNext(); });
    })();
  }

  /* =====================================================================
   * 6. PRICE CONVERSION ENGINE (always from the original USD value)
   * ===================================================================== */
  function formatAmount(amountUsd, currency) {
    var value = amountUsd * rateFor(currency.code);
    var factor = Math.pow(10, currency.decimals);
    value = Math.round(value * factor) / factor;
    var number;
    try {
      number = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: currency.decimals,
        maximumFractionDigits: currency.decimals
      }).format(value);
    } catch (e) {
      number = value.toFixed(currency.decimals);
    }
    return currency.symbol + number;
  }
  function convertText(usdText, currency) {
    return String(usdText).replace(USD_RE, function (match, num) {
      var amount = parseFloat(String(num).replace(/,/g, ''));
      if (isNaN(amount)) { return match; }
      return formatAmount(amount, currency);
    });
  }
  function looksLikeUsd(text) {
    return text.indexOf('$') !== -1 && !OTHER_SYMBOL_RE.test(text);
  }

  /* =====================================================================
   * 7. PRICE RENDERING LAYER (text nodes only — markup is never rewritten)
   * ===================================================================== */
  var usdSource = new WeakMap();
  var activeCurrency = CONFIG.defaultCurrency;

  function textNodesIn(root) {
    var out = [];
    if (!root) { return out; }
    if (root.nodeType === 3) { out.push(root); return out; }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.replace(/\s/g, '')) { return NodeFilter.FILTER_REJECT; }
        var parent = node.parentNode;
        if (parent && parent.closest && parent.closest(SKIP_SELECTOR)) { return NodeFilter.FILTER_REJECT; }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = walker.nextNode())) { out.push(n); }
    return out;
  }
  function rendered(node) {
    var src = usdSource.get(node);
    if (src == null) { return null; }
    if (activeCurrency === CONFIG.baseCurrency) { return src; }
    return convertText(src, currencyOf(activeCurrency));
  }
  function renderNode(node) {
    var expected = rendered(node);
    if (expected == null) { return false; }
    if (node.nodeValue !== expected) { node.nodeValue = expected; }
    return true;
  }
  function renderRoot(root) {
    if (!root || root.nodeType !== 1 || !root.isConnected) { return; }
    var nodes = textNodesIn(root);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var current = node.nodeValue;
      if (!usdSource.has(node)) {
        if (looksLikeUsd(current)) { usdSource.set(node, current); } else { continue; }
      } else if (current !== rendered(node)) {
        // The theme rewrote this price: accept only genuine USD as the new source.
        if (looksLikeUsd(current)) { usdSource.set(node, current); }
      }
      renderNode(node);
    }
  }
  function isLeafPrice(el) {
    return !!el && !!el.querySelector && !el.querySelector(PRICE_SELECTOR);
  }
  function renderAll() {
    var found = document.querySelectorAll(PRICE_SELECTOR);
    var done = [];
    for (var i = 0; i < found.length; i++) {
      var el = found[i];
      if (el.nodeName === 'SCRIPT' || el.nodeName === 'STYLE') { continue; }
      if (el.closest && el.closest(SKIP_SELECTOR)) { continue; }
      if (!isLeafPrice(el)) { continue; }
      if (done.indexOf(el) !== -1) { continue; }
      done.push(el);
      renderRoot(el);
      protectElement(el);
    }
    applyCartNotice();
    applyAttributes();
    if (document.documentElement.classList.contains(CONFIG.pendingClass)) {
      document.documentElement.classList.remove(CONFIG.pendingClass);
    }
  }

  // Keep theme JS (variant price renderer, discount widget) reading the USD value.
  function protectElement(el) {
    if (!CONFIG.protectThemeReads || el.__aoclProtected) { return; }
    el.__aoclProtected = true;
    try {
      Object.defineProperty(el, 'textContent', {
        configurable: true,
        get: function () {
          var nodes = textNodesIn(el);
          return nodes.length ? usdSource.get(nodes[0]) || nodes[0].nodeValue : '';
        },
        set: function (value) {
          var nodes = textNodesIn(el);
          var node = nodes[0];
          if (!node) { node = document.createTextNode(''); el.appendChild(node); }
          usdSource.set(node, String(value));
          renderNode(node);
        }
      });
    } catch (e) {}
  }

  function applyAttributes() {
    var roots = document.querySelectorAll('.pp-price,[data-cart-subtotal],.cart-item-final-price,.gc-price,.gc-tile__price,.aochuan-product-showcase__price,.cmp__val');
    for (var i = 0; i < roots.length; i++) {
      if (activeCurrency === CONFIG.baseCurrency) { roots[i].removeAttribute(CONFIG.activeAttr); }
      else { roots[i].setAttribute(CONFIG.activeAttr, activeCurrency); }
    }
  }

  /* =====================================================================
   * 8. CART NOTICE (subtle, cart page only, hidden while USD is active)
   * ===================================================================== */
  function applyCartNotice() {
    var host = document.querySelector('.cart-price-info');
    if (!host) { return; }
    var existing = host.querySelector('.aocl-notice');
    if (!CONFIG.showCartNotice || activeCurrency === CONFIG.baseCurrency) {
      if (existing) { existing.parentNode.removeChild(existing); }
      return;
    }
    if (!existing) {
      existing = document.createElement('p');
      existing.className = 'cart-message meta aocl-notice';
      host.appendChild(existing);
    }
    if (existing.textContent !== STRINGS.notice) { existing.textContent = STRINGS.notice; }
  }

  /* =====================================================================
   * 9. TARGETED UPDATES (variant change, cart ajax, theme editor)
   * ===================================================================== */
  var observers = [];
  function watchContainers() {
    if (!window.MutationObserver) { return; }
    var roots = document.querySelectorAll(CONFIG.watchSelectors.join(','));
    for (var i = 0; i < roots.length; i++) {
      observe(roots[i]);
    }
  }
  function observe(el) {
    if (!el || el.__aoclWatched) { return; }
    el.__aoclWatched = true;
    var obs = new MutationObserver(function (records) {
      var dirty = [];
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        var root = (target.nodeType === 1 ? target : target.parentNode);
        if (!root || !root.closest) { continue; }
        var priceRoot = root.closest(PRICE_SELECTOR) || root;
        if (dirty.indexOf(priceRoot) === -1) { dirty.push(priceRoot); }
      }
      if (!dirty.length) { return; }
      schedule(function () { for (var j = 0; j < dirty.length; j++) { renderRoot(dirty[j]); } applyCartNotice(); });
    });
    obs.observe(el, { childList: true, subtree: true, characterData: true });
    observers.push(obs);
  }
  var scheduled = false;
  function schedule(fn) {
    if (scheduled) { return; }
    scheduled = true;
    var run = function () { scheduled = false; fn(); };
    if (window.requestAnimationFrame) { window.requestAnimationFrame(run); } else { window.setTimeout(run, 16); }
  }
  function bindThemeEvents() {
    document.addEventListener('shopify:section:load', function () { schedule(function () { renderAll(); watchContainers(); }); });
    document.addEventListener('shopify:section:unload', function () { observers.length = 0; });
  }

  /* =====================================================================
   * 10. HEADER SELECTOR (currency + Shopify locale)
   * ===================================================================== */
  function buildCurrencyMenu(scope) {
    var host = scope.querySelector('[data-aocl-currencies]');
    if (!host || host.__aoclBuilt) { return; }
    host.__aoclBuilt = true;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < CURRENCY_LIST.length; i++) {
      var c = CURRENCY_LIST[i];
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'aocl-item';
      btn.setAttribute('data-aocl-currency', c.code);
      btn.innerHTML = '<span>' + c.code + '</span><span class="aocl-symbol">' + c.symbol + '</span>';
      li.appendChild(btn);
      frag.appendChild(li);
    }
    host.appendChild(frag);
  }
  function syncSelector(scope) {
    var label = scope.querySelector('[data-aocl-label]');
    if (label) { label.textContent = activeCurrency; }
    var cur = scope.querySelectorAll('[data-aocl-currency]');
    for (var i = 0; i < cur.length; i++) {
      var on = cur[i].getAttribute('data-aocl-currency') === activeCurrency;
      cur[i].classList[on ? 'add' : 'remove']('is-active');
      cur[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var loc = scope.querySelectorAll('[data-aocl-locale]');
    for (var j = 0; j < loc.length; j++) {
      var onL = loc[j].getAttribute('data-aocl-locale') === DATA.locale;
      loc[j].classList[onL ? 'add' : 'remove']('is-active');
      loc[j].setAttribute('aria-pressed', onL ? 'true' : 'false');
    }
  }
  function closePanel(scope) {
    scope.classList.remove('is-open');
    var toggle = scope.querySelector('[data-aocl-toggle]');
    var panel = scope.querySelector('[data-aocl-panel]');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); }
    if (panel) { panel.setAttribute('aria-hidden', 'true'); }
  }
  function openPanel(scope) {
    scope.classList.add('is-open');
    var toggle = scope.querySelector('[data-aocl-toggle]');
    var panel = scope.querySelector('[data-aocl-panel]');
    if (toggle) { toggle.setAttribute('aria-expanded', 'true'); }
    if (panel) { panel.setAttribute('aria-hidden', 'false'); }
  }
  function setCurrency(code, manual) {
    if (!isSupported(code)) { return; }
    activeCurrency = String(code).toUpperCase();
    writePreference(activeCurrency, manual !== false);
    renderAll();
    var scopes = document.querySelectorAll('[data-aocl]');
    for (var i = 0; i < scopes.length; i++) { syncSelector(scopes[i]); }
  }
  function initSelector(scope) {
    if (scope.__aoclInit) { return; }
    scope.__aoclInit = true;
    buildCurrencyMenu(scope);
    syncSelector(scope);

    scope.addEventListener('click', function (event) {
      var el = event.target;
      var toggle = el.closest('[data-aocl-toggle]');
      if (toggle && scope.contains(toggle)) {
        event.preventDefault();
        if (scope.classList.contains('is-open')) { closePanel(scope); } else { openPanel(scope); }
        return;
      }
      var currencyBtn = el.closest('[data-aocl-currency]');
      if (currencyBtn && scope.contains(currencyBtn)) {
        event.preventDefault();
        setCurrency(currencyBtn.getAttribute('data-aocl-currency'), true);
        closePanel(scope);
        return;
      }
      var localeBtn = el.closest('[data-aocl-locale]');
      if (localeBtn && scope.contains(localeBtn)) {
        event.preventDefault();
        var form = scope.querySelector('form[action*="localization"]');
        var input = scope.querySelector('[data-aocl-locale-input]');
        if (form && input) {
          input.value = localeBtn.getAttribute('data-aocl-locale');
          form.submit();
        }
        return;
      }
    });
    document.addEventListener('click', function (event) {
      if (!scope.contains(event.target)) { closePanel(scope); }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closePanel(scope); }
    });
  }

  /* =====================================================================
   * 11. BOOTSTRAP
   * ===================================================================== */
  function boot() {
    var saved = readPreference();
    activeCurrency = saved && saved.manual ? saved.code : detectedCurrency();
    if (!isSupported(activeCurrency)) { activeCurrency = resolveCurrency(); }
    if (!saved) { writePreference(activeCurrency, false); }

    var scopes = document.querySelectorAll('[data-aocl]');
    for (var i = 0; i < scopes.length; i++) { initSelector(scopes[i]); }

    renderAll();
    watchContainers();
    bindThemeEvents();
    document.documentElement.classList.remove(CONFIG.pendingClass);

    refreshRates(function () {
      renderAll();
      var all = document.querySelectorAll('[data-aocl]');
      for (var j = 0; j < all.length; j++) { syncSelector(all[j]); }
    });
  }

  window.AOCLocalization = {
    config: CONFIG,
    strings: STRINGS,
    get currency() { return activeCurrency; },
    convert: function (amountUsd, code) { return formatAmount(amountUsd, currencyOf(code || activeCurrency)); },
    format: function (amountUsd, code) { return formatAmount(amountUsd, currencyOf(code || activeCurrency)); },
    setCurrency: function (code) { setCurrency(code, true); },
    detect: function () { return { country: detectCountry(), currency: detectedCurrency() }; },
    refreshRates: function () { rateRequested = false; refreshRates(function () { renderAll(); }); },
    render: renderAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();